// dependencies
import * as Sentry from "@sentry/react";
import { List, Map } from "immutable";

// utils
import camelfy from "../utils/Camelfy";

const initialState = Map();

const permissionsReducer = (state = initialState, action) => {
	switch (action.type) {
		/**
		 * Gets permissions for an object
		 */
		case "PERMISSIONS:GETOBJECT@SUCCESS": {
			try {
				const { domain, objectValue } = action.request.props;
				const camelDomain = camelfy(domain);

				return state.setIn([camelDomain, "objects", objectValue], action.response);
			} catch (ermahgerd) {
				Sentry.captureException(ermahgerd);
			}

			return state;
		}

		case "PERMISSIONS:GETDOMAIN@SUCCESS": {
			try {
				const { domain } = action.request.props;
				const camelDomain = camelfy(domain);
				return state.setIn([camelDomain, "permissionList"], action.response.get("permissions", List()));
			} catch (ermahgerd) {
				Sentry.captureException(ermahgerd);
			}

			return state;
		}

		case "PERMISSIONS:GetRBACEMPLOYEE@SUCCESS": {
			try {
				return state.setIn(["rbacPermissionsList"], action.response);
			} catch (ermahgerd) {
				Sentry.captureException(ermahgerd);
			}

			return state;
		}

		case "PERMISSIONS:GetRbacDomainPermissions@SUCCESS": {
			try {
				return state.setIn(["rbacPermissionsList"], action.response);
			} catch (ermahgerd) {
				Sentry.captureException(ermahgerd);
			}

			return state;
		}

		default: {
			return state;
		}
	}
};

export default permissionsReducer;
